import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createAdvertisement = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}/common?table=advertisement`,
    data
  );
  return res.data;
};

export const getAllAdvertisement = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/advertisement?start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getAdvertisementById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/employee/${id}`);
  return res.data;
};
export const deleteAdvertisementById = async (id) => {
  const res = await axios.delete(
    `${API_BASE_URL}/common?table=advertisement&id=${id}`
  );
  return res.data;
};
